import cities from "@/data/citiesOptionFormatter.json"
import provinces from "@/data/provincesOptionFormatter.json"
import industryGroups from "@/data/industryGroup.json"

// eslint-disable-next-line no-unused-vars
let faculties = [
  "วศ.บ. วิศวกรรมการผลิตชิ้นส่วนยานยนต์",
  "วท.บ. วิทยาศาสตร์ข้อมูลสุขภาพ",
  "วศ.บ. วิศวกรรมคอมพิวเตอร์",
  "วศ.บ. วิศวกรรมคอมพิวเตอร์ (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมเคมี ",
  "วศ.บ. วิศวกรรมเคมี (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมเครื่องกล",
  "วศ.บ. วิศวกรรมเครื่องกลและพลังงาน",
  "วศ.บ. วิศวกรรมเครื่องมือ",
  "วศ.บ. วิศวกรรมไฟฟ้า",
  "วศ.บ. วิศวกรรมไฟฟ้า (ระบบไฟฟ้า อิเล็กทรอนิกส์ และพลังงาน)",
  "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์",
  "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์ (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมเมคคาทรอนิกส์",
  "วศ.บ. วิศวกรรมยานยนต์",
  "วศ.บ. วิศวกรรมโยธา",
  "วศ.บ. วิศวกรรมโยธา (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมระบบควบคุมและเครื่องมือวัด",
  "วศ.บ. วิศวกรรมวัสดุ",
  "วศ.บ. วิศวกรรมสิ่งแวดล้อม",
  "วศ.บ. วิศวกรรมสิ่งแวดล้อม (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมอัตโนมัติ (หลักสูตรนานาชาติ) ",
  "วศ.บ. วิศวกรรมอุตสาหการ"
];

// const apiHostUrlDirectly = "https://eng-jobfair.herokuapp.com/api";
const apiHostUrlDirectly = "https://engjob.kmutt.ac.th/api";
// const apiHostUrlDirectly = "http://engjob.pj.innosoft.kmutt.ac.th/api";
// const apiHostUrlDirectly = window.location.origin+"/api";

export default {
  companyFormFormatter(company) {

    let companyDataForm = {};

    companyDataForm["display"] = [{url: `${apiHostUrlDirectly}/public/${company.display}`}];
    companyDataForm["brochure"] = [{url: `${apiHostUrlDirectly}/public/${company.brochure}`}];

    companyDataForm["name-th"] = company.name.th;
    companyDataForm["name-en"] = company.name.en;

    companyDataForm["status"] = company.status;

    for (const [key, value] of Object.entries(industryGroups)) {
      if (company.industry_group.industry === value) {
        companyDataForm["industry_group-industry"] = key
      }


      if (key === "industry17" && company.industry_group.otherIndustry) {
        companyDataForm["industry_group-otherIndustry"] = company.industry_group.otherIndustry;
      } else {
        companyDataForm["industry_group-otherIndustry"] = ""
      }
    }

    companyDataForm["website"] = company.website;
    companyDataForm["email"] = company.email;
    companyDataForm["interest_faculties"] = company.interest_faculties;
    companyDataForm["description"] = company.description;
    companyDataForm["available_job"] = company.available_job;

    companyDataForm["address-building_road"] = company.address.building_road;

    for (const [key, value] of Object.entries(provinces)) {
      if (company.address.province === value) {
        companyDataForm["address-province"] = key
      }
    }
    for (const [key, value] of Object.entries(cities)) {
      if (company.address.city === value) {
        companyDataForm["address-city"] = key
      }
    }

    companyDataForm["address-zip_code"] = company.address.zip_code;

    if (company.contact_person) {
      companyDataForm["contact_person-email"] = company.contact_person.email;
      companyDataForm["contact_person-firstName"] = company.contact_person.firstName;
      companyDataForm["contact_person-lastName"] = company.contact_person.lastName;
      companyDataForm["contact_person-phone"] = company.contact_person.phone;
      companyDataForm["contact_person-position"] = company.contact_person.position;
    }

    if (company.meeting_times) {
      const haveMeeting = company.meeting_times.filter(meeting => meeting.checked === true);
      companyDataForm["isOnline_enable"] = haveMeeting.length > 0 ? 'yes' : 'no'
      if (haveMeeting.length > 0) {
        company.meeting_times.forEach((meetingDay, meetingIndex) => {
          const isEnableAfternoon = meetingDay.ranges && meetingDay.ranges.afternoon && meetingDay.ranges.afternoon.checked && meetingDay.ranges.afternoon.checked === true ? 'yes' : 'no'
          const isEnableMorning = meetingDay.ranges && meetingDay.ranges.morning && meetingDay.ranges.morning.checked && meetingDay.ranges.morning.checked === true ? 'yes' : 'no'
          if (meetingIndex === 0) {
            companyDataForm[`dayOne_date`] = meetingDay.date

            companyDataForm[`formData_isOnline_dayOne_afternoon`] = [
              {
                "isOnline_dayOne_afternoon-enable": isEnableAfternoon,
                start_time: meetingDay.ranges.afternoon.start_time,
                end_time: meetingDay.ranges.afternoon.end_time,
                meeting_link: meetingDay.ranges.afternoon.meeting_link
              }
            ];

            companyDataForm[`formData_isOnline_dayOne_morning`] = [
              {
                "isOnline_dayOne_morning-enable": isEnableMorning,
                start_time: meetingDay.ranges.morning.start_time,
                end_time: meetingDay.ranges.morning.end_time,
                meeting_link: meetingDay.ranges.morning.meeting_link
              }
            ];
          }

          if (meetingIndex === 1) {
            companyDataForm[`dayTwo_date`] = meetingDay.date

            companyDataForm[`formData_isOnline_dayTwo_afternoon`] = [
              {
                "isOnline_dayTwo_afternoon-enable": isEnableAfternoon,
                start_time: meetingDay.ranges && meetingDay && meetingDay.ranges.afternoon && meetingDay.ranges.afternoon.start_time,
                end_time: meetingDay.ranges && meetingDay && meetingDay.ranges.afternoon && meetingDay.ranges.afternoon.end_time,
                meeting_link: meetingDay.ranges && meetingDay && meetingDay.ranges.afternoon && meetingDay.ranges.afternoon.meeting_link
              }
            ];

            companyDataForm[`formData_isOnline_dayTwo_morning`] = [
              {
                "isOnline_dayTwo_morning-enable": isEnableMorning,
                start_time: meetingDay && meetingDay.ranges && meetingDay.ranges.morning && meetingDay.ranges.morning.start_time,
                end_time: meetingDay && meetingDay.ranges && meetingDay.ranges.morning && meetingDay.ranges.morning.end_time,
                meeting_link: meetingDay && meetingDay.ranges && meetingDay.ranges.morning && meetingDay.ranges.morning.meeting_link
              }
            ];
          }
        })
      }
    }
    return companyDataForm
  },

  registerFormatter(form) {
    let registerForm = {}
    for (const [key, value] of Object.entries(form)) {
      let trees = key.split("-")
      if (value) {
        if (trees.length === 1) {
          registerForm[trees[0]] = value
        }
        if (trees.length === 2) {
          if (!registerForm[trees[0]]) {
            registerForm[trees[0]] = {}
          }
          registerForm[trees[0]][trees[1]] = value
        }
      }
    }
    return registerForm
  },

  registerCompanyFormatter(form) {
    let registerForm = this.registerFormatter(form)
    return {
      username: registerForm.email,
      password: registerForm.password,
      name: registerForm.contact_person.firstName,
      surname: registerForm.contact_person.lastName,
      email: registerForm.contact_person.email,
      phone: registerForm.contact_person.phone,
      position: registerForm.contact_person.position
    }
  },

  registerStudentFormatter(form) {

    return this.registerFormatter(form)
  },

  registerFormFormatter(student) {
    let studentDataForm = {};


    studentDataForm["resume_file_recovery"] = `${apiHostUrlDirectly}/public/students/${student.resume_file}`;
    studentDataForm["image_file_recovery"] = `${apiHostUrlDirectly}/public/students/${student.image_file}`;

    studentDataForm["resume_file"] = [{url: studentDataForm["resume_file_recovery"]}];
    studentDataForm["image_file"] = [{url: studentDataForm["image_file_recovery"]}];

    studentDataForm["th-title"] = student.th.title ? student.th.title : "";
    studentDataForm["th-name"] = student.th.name ? student.th.name : "";
    studentDataForm["th-surname"] = student.th.surname ? student.th.surname : "";

    studentDataForm["en-title"] = student.en.title ? student.en.title : "";
    studentDataForm["en-name"] = student.en.name ? student.en.name : "";
    studentDataForm["en-surname"] = student.en.surname ? student.en.surname : "";

    studentDataForm["address-address"] = student.address.address ? student.address.address : "";
    for (const [key, value] of Object.entries(provinces)) {
      if (student.address.province === value || student.address.province === key) {
        studentDataForm["address-province"] = key
      }
    }
    for (const [key, value] of Object.entries(cities)) {
      if (student.address.city === value || student.address.city === key) {
        studentDataForm["address-city"] = key
      }
    }
    studentDataForm["address-zip_code"] = student.address.zip_code ? student.address.zip_code : "";

    studentDataForm["bio"] = student.bio ? student.bio : "";
    studentDataForm["birth_of_date"] = student.birth_of_date ? student.birth_of_date : "";
    studentDataForm["blood_type"] = student.blood_type ? student.blood_type : "";
    studentDataForm["curriculum"] = student.curriculum ? student.curriculum : "";
    studentDataForm["email"] = student.email ? student.email : "";
    studentDataForm["phone"] = student.phone ? student.phone : "";
    studentDataForm["student_id"] = student.student_id ? student.student_id : "";

    studentDataForm["language_ability"] = student.language_ability ? student.language_ability : [];

    return studentDataForm
  },

  studentFormatterRemoveFiles(form) {
    delete form.image_file;
    delete form.resume_file;
    delete form.image_file_recovery;
    delete form.resume_file_recovery;

    return form;
  },

  companyInformation(form) {

    let registerForm = {}

    for (const [key, value] of Object.entries(form)) {
      let trees = key.split("-")
      if (value) {
        if (trees.length === 1) {
          registerForm[trees[0]] = value
        }
        if (trees.length === 2) {
          if (!registerForm[trees[0]]) {
            registerForm[trees[0]] = {}
          }
          registerForm[trees[0]][trees[1]] = value
        }
      }
    }

    for (const [key, value] of Object.entries(provinces)) {
      if (registerForm.address.province === key) {
        registerForm.address.province = value
      }
    }
    for (const [key, value] of Object.entries(cities)) {
      if (registerForm.address.city === key) {
        registerForm.address.city = value
      }
    }
    for (const [key, value] of Object.entries(industryGroups)) {
      if (registerForm.industry_group.industry === key) {
        registerForm.industry_group.industry = value
      }
    }

    delete registerForm.display;
    delete registerForm.brochure;

    return registerForm;
  },

  citiesFilter(provinceCode) {
    let pattern = ``;
    if (provinceCode) {
      pattern = provinceCode + `(\\d[0-9])`;
    } else {
      return {}
    }
    const regex = new RegExp(pattern);
    let citiesByProvince = {}
    for (const [key, value] of Object.entries(cities)) {
      if (regex.test(key)) {
        citiesByProvince[key] = value;
      }
    }
    return citiesByProvince
  },

  jobEditorFormFormatter(job, company) {
    let closeDateReverseFormat = "";
    let postDateTimeFormat = "";
    let postDateTimeReverse = "";

    if (job.close_date) {
      closeDateReverseFormat = job.close_date;
      let close_data = job.close_date.split("-");
      closeDateReverseFormat = `${close_data[2]}-${close_data[1]}-${close_data[0]}`
    }
    if (job.post_date) {
      postDateTimeFormat = job.post_date;
      postDateTimeReverse = job.post_date;
      let post_date = job.post_date.split("-");
      if (post_date[0] > 1000) {
        postDateTimeFormat = new Date(`${post_date[0]}-${post_date[1]}-${post_date[2]}`)
        postDateTimeReverse = `${post_date[2]}-${post_date[1]}-${post_date[0]}`
      } else {
        postDateTimeFormat = new Date(`${post_date[2]}-${post_date[1]}-${post_date[0]}`)
        postDateTimeReverse = `${post_date[0]}-${post_date[1]}-${post_date[2]}`
      }
    }

    job.position = {
      name: job.job_name,
      company: company.name.th,
      date: postDateTimeReverse.replaceAll("-", "/"),
      postDate: this.timeDifference(new Date(), postDateTimeFormat),
      closeDate: closeDateReverseFormat.replaceAll("-", "/"),
      jobType: job.job_type,
      display: company.display,
      location: `${company.address.city}, ${company.address.province}`
    }

    return job
  },

  timeDifference(current, previous) {

    let msPerMinute = 60 * 1000;
    let msPerHour = msPerMinute * 60;
    let msPerDay = msPerHour * 24;
    let msPerMonth = msPerDay * 30;
    let msPerYear = msPerDay * 365;

    let elapsed = current - previous;

    if (elapsed < msPerMinute) {
      return Math.round(elapsed / 1000) + ' วินาทีที่ผ่านมา';
    } else if (elapsed < msPerHour) {
      return Math.round(elapsed / msPerMinute) + ' นาทีที่ผ่านมา';
    } else if (elapsed < msPerDay) {
      return Math.round(elapsed / msPerHour) + ' ชั่วโมงที่ผ่านมา';
    } else if (elapsed < msPerMonth) {
      return Math.round(elapsed / msPerDay) + ' วันที่ผ่านมา';
    } else if (elapsed < msPerYear) {
      return Math.round(elapsed / msPerMonth) + ' เดือนที่ผ่านมา';
    } else {
      return Math.round(elapsed / msPerYear) + ' ปีที่ผ่านมา';
    }
  }

};